export const CURRENT_USER_ABSOLUTE_ROUTE_PREFIX =
  '/navix-admin/current-user/s' as const
export const SWITCH_TENANT_DIALOG_ID = 'SWITCH_TENANT_DIALOG_ID' as const
